import React, { useEffect, useState } from 'react'
import DetailsHeaders from './DetailsHeaders'
import DetailsBody from './DetailsBody'
import PersonDetails from './PersonDetails'
import CreateTaskModal from './CreateTaskModal'
import CreateNoteModal from './CreateNoteModal'
import "../../styles.css"
import "./style.css"
import {
  setPersonData
} from "ReduxStore/Slices/accountSlice";
import { useDispatch, useSelector } from "react-redux";

import {
  getPersonById
} from "api/AccountsApi";

export default function Details(props) {


  const dispatch = useDispatch();
  const [personData, setPersonData] = useState(null);


  const ACTIVITY_TAB = {
    name: 'Activity',
    id: 'ACTIVITY_TAB',
    status: 'active',
  }
  const PROFILE_TAB = {
    name: 'Profile',
    id: 'PROFILE_TAB',
    status: '',
  }
  const TASKS_TAB = {
    name: 'Tasks',
    id: 'TASKS_TAB',
    status: '',
  }
  const NOTES_TAB = {
    name: 'Notes',
    id: 'NOTES_TAB',
    status: '',
  }

  if (!personData) {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var id = url.searchParams.get("id");
    getPersonById(id).then(person => {

      if (person)
        person.tags = person.tags.map(obj => obj.tag)
      setPersonData(person)

    })
  }

  function refetchPerson() {
    console.log("refetchPerson")
    var url_string = window.location.href;
    var url = new URL(url_string);
    var id = url.searchParams.get("id");

    getPersonById(id).then(person => {
      if (person)
        person.tags = person.tags.map(obj => obj.tag)

      setPersonData(person)

    })
  }


  const TABS = [ACTIVITY_TAB, PROFILE_TAB, TASKS_TAB, NOTES_TAB];

  const [currentTab, setCurrentTab] = useState(ACTIVITY_TAB);

  const tabChanged = (tab) => {
    setCurrentTab(tab);
  }
  useEffect(() => {
    var url_string = window.location.href;
    var url = new URL(url_string);
    var tab = url.searchParams.get("tab");
    if(tab =='profile'){
        setTimeout(function () {
          try {
          document.getElementById('profileTabLink').click()
        }catch (e) { }
        },2000)
 
    }

  }, [])

  return (
    <>
      <div className='container' style={{ height: `100%` }}>
        <div className='row' style={{ height: "100%", marginRight: '0px' }}>
          <div className='col tasks' style={{ height: "100%", paddingRight: 0 }} >
            <DetailsHeaders currentTab={currentTab}  data={personData}  />
            {personData && <DetailsBody TABS={TABS} currentTab={currentTab} tabChanged={tabChanged} personData={personData} refetchPerson={refetchPerson} />}
          </div>
          {/* {
            //Condition for showing the person profile while we change the tab
            !(currentTab.id === 'PROFILE_TAB') && <div className='col-3 person-profile' style={{ height: "100%", maxWidth: "300px", overflow: 'hidden' }}>
              {personData && <PersonDetails data={personData} tabChanged={tabChanged} />}
            </div>
          } */}
        </div>

      </div>
    </>
  )
}
